<template>
  <div class="content-box">
    <Title />

    <el-menu
      :default-active="activeIndex"
      class="el-menu-demo"
      mode="horizontal"
    >
      <el-menu-item
        :index="String(index + 1)"
        v-for="(i, index) of dataNav"
        :key="index"
        @click="handleSelect(index)"
      >
        {{ i.label }}</el-menu-item
      >
    </el-menu>

    <div class="mobile-select">
      <el-select v-model="name" @change="handleSelect2">
        <el-option
          v-for="item in dataNav"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>

    <Project />
  </div>
</template>

<script>
import { Project } from "shared";

export default {
  name: "project",
  components: {
    Project,
  },
  data() {
    return {
      activeIndex: "1",
      name: "投诉",
      dataNav: [
        {
          value: "投诉",
          label: "投诉",
        },
        {
          value: "调查行动",
          label: "调查行动",
        },
      ],
    };
  },
  created() {
    this.$store.dispatch("getProject", this.dataNav[0].value);
  },
  methods: {
    handleSelect(index) {
      this.$store.dispatch("getProject", this.dataNav[index].value);
    },
    handleSelect2(value) {
      this.$store.dispatch("getProject", value);
    },
  },
};
</script>